import { frontEndExcludedHosts } from '~/logging-excluded-hosts.ts'

const isLocalHost = (hostName: string) =>
  hostName === 'localhost' || hostName.includes('local.magicsky.quickframe.com')

const isExcludedHost = (hostName: string) =>
  frontEndExcludedHosts.includes(hostName)

export const isFrontEndTelemetryEnabled = () => {
  if (typeof window === 'undefined') {
    return false
  }

  const hostName = window.location.hostname.toLowerCase()
  return !isLocalHost(hostName) && !isExcludedHost(hostName)
}
